import React from "react"
import { Redirect } from "react-router-dom"

import useAuth from "../../hooks/useAuth"
import { RoutePaths } from "../../routes/RoutePaths"

// eslint-disable-next-line react/prop-types
const GuestGuard = ({ children }) => {
  const { isLoggedIn } = useAuth()

  if (isLoggedIn) {
    return <Redirect to={RoutePaths.DASHBOARD} />
  }

  return <React.Fragment>{children}</React.Fragment>
}

export default GuestGuard
